// 统一的 Modal 设计样式常量
export const modalStyles = {
  // 主色调
  primary: '#8BC9A3',
  primaryDark: '#6FB890',
  primaryLight: '#a8d7b7',

  // 文字颜色
  titleColor: '#1B3B2E',
  textPrimary: '#374151',
  textSecondary: '#6b7280',

  // 背景色
  bgLight: '#f9fdfb',
  bgWhite: '#ffffff',
  bgGray: '#f8fafc',

  // 边框颜色
  borderPrimary: '#8BC9A3',
  borderSecondary: '#e5e7eb',
  borderLight: '#e8f5ed',

  // 功能色
  success: '#10b981',
  warning: '#f59e0b',
  danger: '#ef4444',
  info: '#3b82f6',

  // 尺寸
  borderRadius: '12px',
  borderRadiusSmall: '8px',
  borderRadiusTiny: '6px',

  // 间距
  padding: '24px',
  paddingSmall: '16px',
  paddingTiny: '8px',

  // 阴影
  shadow: '0 4px 24px rgba(27, 59, 46, 0.15)',
  shadowSmall: '0 2px 8px rgba(27, 59, 46, 0.1)',
}

// 标题样式 - 居中头部
export const titleStyle = {
  color: modalStyles.titleColor,
  fontSize: '18px',
  fontWeight: 600,
  marginBottom: '16px',
  textAlign: 'center' as const,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px'
}

// 彩色指示条样式
export const indicatorStyle = (color: string) => ({
  display: 'inline-block',
  width: '3px',
  height: '18px',
  backgroundColor: color,
  borderRadius: '2px'
})

// 表头样式
export const tableHeaderStyle = {
  backgroundColor: '#f8fafc',
  backgroundImage: 'linear-gradient(to bottom, #f8fafc 0%, #f1f5f9 100%)'
}

// 按钮样式
export const buttonStyles = {
  primary: {
    backgroundColor: modalStyles.primary,
    borderColor: modalStyles.primary,
    color: '#ffffff',
    fontWeight: 600,
    borderRadius: modalStyles.borderRadiusTiny,
    boxShadow: `0 4px 12px rgba(139, 201, 163, 0.3)`
  },
  secondary: {
    backgroundColor: '#ffffff',
    borderColor: modalStyles.primary,
    color: modalStyles.primary,
    fontWeight: 500,
    borderRadius: modalStyles.borderRadiusTiny
  },
  info: {
    backgroundColor: modalStyles.info,
    borderColor: modalStyles.info,
    color: '#ffffff',
    fontWeight: 600,
    borderRadius: modalStyles.borderRadiusTiny,
    boxShadow: `0 4px 12px rgba(59, 130, 246, 0.3)`
  },
  success: {
    backgroundColor: modalStyles.success,
    borderColor: modalStyles.success,
    color: '#ffffff',
    fontWeight: 600,
    borderRadius: modalStyles.borderRadiusTiny,
    boxShadow: `0 4px 12px rgba(16, 185, 129, 0.3)`
  },
  warning: {
    backgroundColor: modalStyles.warning,
    borderColor: modalStyles.warning,
    color: '#ffffff',
    fontWeight: 600,
    borderRadius: modalStyles.borderRadiusTiny,
    boxShadow: `0 4px 12px rgba(245, 158, 11, 0.3)`
  }
}

// 表格边框样式
export const tableBorder = {
  border: '1px solid #e5e7eb',
  borderCollapse: 'collapse' as const
}

// 表格单元格样式
export const tableCellStyle = {
  border: '1px solid #e5e7eb',
  padding: '12px 8px',
  fontSize: '13px'
}

// Modal 容器样式
export const modalContainerStyle = {
  padding: '8px'
}

// 渐变头部区域样式（用于 PO 信息展示）
export const gradientHeaderStyle = {
  background: `linear-gradient(135deg, ${modalStyles.primary} 0%, ${modalStyles.primaryDark} 100%)`,
  borderRadius: '10px',
  padding: '16px 20px',
  marginBottom: '20px',
  boxShadow: `0 4px 12px rgba(139, 201, 163, 0.15)`
}

// 头部信息项样式
export const headerItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
}

// 头部标签样式
export const headerLabelStyle = {
  fontSize: '13px',
  color: 'rgba(255,255,255,0.85)',
  fontWeight: 500
}

// 头部值样式
export const headerValueStyle = {
  fontSize: '15px',
  fontWeight: 600,
  color: '#ffffff'
}
